module.exports = __webpack_public_path__ + "static/media/muli-latin-200italic.ed5f4d70.woff2";